import MainTitle from '../../components/MainTitle'
import { useState, useEffect, Link, Fragment } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth';
import { useParams, useLocation, useNavigate, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faPhoneVolume, faComments, faChevronRight, faSchool  } from '@fortawesome/free-solid-svg-icons'

const MySchool = () => {
  const { id } = useParams()
  const { setShowLoader, can, createInfo, auth, admin } = useAuth()
  const axios = useAxiosPrivate()
  const [enquiry, setEnquiry] = useState(null)
  const [open, setOpen] = useState(false)
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  });

  const [school, setSchool] = useState(null)

  useEffect(() => {
    fetchSchool()
  }, [])

  const fetchSchool = async () => {
    setShowLoader(true)
    try {
      const response = await axios.get(`/user/organisation/${auth?.user?.id}`);
      if (response.data.error) {
        console.error(response.data.message);
      } else {
        setSchool(response.data.result);
      }
    } catch (error) {
      console.error('Error fetching school:', error);
    } finally {
      setShowLoader(false)
    }
  }

  return (
    <section>
      <MainTitle title="My School" />
      <section className="">
        {/* Next Appointment */}
        <div className="mb-6 pb-6 border-b border-b-[#DDCCDF]">
          <div className="bg-white border-l-8 border-l-[#969EF4] shadow-md rounded-xl flex items-center justify-between p-4 max-w-md">
            <div className="pl-2 space-y-2">
              <FontAwesomeIcon icon={faSchool} className="text-[#979EF4] text-xl" />
              <div>
                <h3 className="font-semibold text-lg">{school?.name}</h3>
                <p className="text-sm text-gray-600">{school?.address}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default MySchool
